module.exports = __webpack_public_path__ + "img/22.2cbd8b05.jpg";